module.exports = __webpack_public_path__ + "img/spinner_grey.b2c3719f.gif";